const SET_SOLD_STATUS = 'SET_SOLD_STATUS';
const SET_ARCHIVE_STATUS = 'SET_ARCHIVE_STATUS';
const SET_JOB_STATUS = 'SET_JOB_STATUS';
const SET_PROJECT_TOKEN = 'SET_PROJECT_TOKEN';

export {
    SET_SOLD_STATUS,
    SET_ARCHIVE_STATUS,
    SET_JOB_STATUS,
    SET_PROJECT_TOKEN,
};



// WEBPACK FOOTER //
// ./src/containers/common/projectstatus/constants.js